{
  "pet": {
    "idle": ["sit_0", "sit_1", "sit_0", "sit_blink_0", "sit_0", "sit_1", "sit_0", "sit_blink_1"],
    "happy": ["sit_happy_0", "sit_happy_1"],
    "eating": ["eat"],
    "resting": ["lie"],
    "lastChance": ["lie"],
    "dead": ["lie"]
  },
  "swimmer": {
    "idle": ["swim_0", "swim_1"],
    "happy": ["swim_happy_0", "swim_happy_1"],
    "eating": ["eat"],
    "resting": ["rest"],
    "lastChance": ["sad_0"],
    "dead": ["sad_0"]
  }
}
